import { baseSepolia, zora } from 'viem/chains';
import { isProductionNetwork } from '../../../config';

export const TOKEN_SOURCE_CHAIN = isProductionNetwork ? zora : baseSepolia;
